<template>
  <!-- 有留slot放附約選擇組件 -->
  <div class="MainProductInputItem">
    <h4 class="d-flex align-items-center">
      建議{{ mainIndex + 1 }}:{{ productData.prod_name.slice(0, 40) }}
      <template v-if="productData.prod_name.length > 40">
        <br />
        {{ productData.prod_name.slice(40) }}
      </template>
      ({{
        productData.prod_id
      }}){{ `${productData.risk_ind ? productData.risk_ind : ""}` }}
      <div
        class="btn btn-default btn-sm px_2 pt_2 ml_15"
        @click.stop="$emit('delete')"
      >
        <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
      </div>
    </h4>
    <div v-if="has_hnw" class="notice-large">
      本商品要保人須申請成為高資產客戶(如:提具1億元以上淨資產並具專業投資經驗)，請務必詳閱業務員須知，以利後續核保作業。
    </div>
    <div class="text-red notice">{{ whiteListErrorMessage }}</div>
    <div class="text-red notice">{{ errorMessage }}</div>
    <div class="form-group row mt_12 align-items-center">
      <div class="col-12 d-flex align-items-center">
        <div class="d-flex align-items-center">
          <!-- 繳費年期 -->
          <label :for="mainIndex + 'pay_prd'">繳費年期:</label>
          <select
            class="form-control"
            style="width: 7rem"
            :id="mainIndex + 'pay_prd'"
            :data-vv-name="mainIndex + 'pay_prd'"
            :class="{ 'is-invalid': errors.has(mainIndex + 'pay_prd') }"
            v-validate="`required|checkPrd_${productData.prod_id}_${uniqueKey}`"
            data-vv-as="繳費年期"
            @change="($event) => changePeriod($event)"
            :value="productDataScope.pay_prd"
          >
            <option value="" disabled>請選擇</option>
            <option
              v-for="(periodOption, index) in validPayPrdOption"
              :key="index"
              :value="periodOption"
            >
              {{ periodOption }}
            </option>
          </select>
          <div class="text-red notice ml_4">
            根據要/被保人資訊自動剔除不適用之繳費年期
          </div>
          <span v-if="extra__payPeriodMatur" class="pl-1">歲滿期</span>
        </div>
        <div>
          <div
            class="noPremium ml_8"
            v-if="
              extra__payPeriodMatur &&
              errorMessage == '' &&
              productData.pay_prd -
                $store.getters.MfEditing.insured.insured_age >
                -1
            "
          >
            繳費年期{{
              productData.pay_prd -
              $store.getters.MfEditing.insured.insured_age
            }}年
          </div>
        </div>
      </div>
    </div>

    <!-- 保險期間 -->
    <div class="form-group row mt_12" v-if="extra__showPolPeriod">
      <div class="col-12 d-flex align-items-center">
        <label :for="mainIndex + 'pol_period'">保險期間:</label>
        <select
          class="form-control"
          style="width: 7rem"
          :id="mainIndex + 'pol_period'"
          :data-vv-name="mainIndex + 'pol_period'"
          :class="{ 'is-invalid': errors.has(mainIndex + 'pol_period') }"
          v-validate="`required|checkPol_${productData.prod_id}_${uniqueKey}`"
          data-vv-as="保險期間"
          v-model="productDataScope.pol_period"
          :disabled="extra_pay_to_pol"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(polPeriodOption, index) in extra__polPeriodOption"
            :key="index"
            :value="polPeriodOption"
          >
            {{ polPeriodOption }}
          </option>
        </select>
        <span v-if="extra__polPeriodMatur" class="pl-1">歲滿期</span>
      </div>
    </div>
    <!-- 遞延期間(8/2新增) -->
    <div class="form-group row mt_12" v-if="extra__showDeferred">
      <div class="col-12 d-flex align-items-center">
        <label :for="mainIndex + 'deferred_prod'">遞延期間:</label>
        <select
          class="form-control"
          style="width: 7rem"
          :id="mainIndex + 'deferred_prod'"
          :data-vv-name="mainIndex + 'deferred_prod'"
          :class="{ 'is-invalid': errors.has(mainIndex + 'deferred_prod') }"
          v-validate="
            `required|checkDeferred_${productData.prod_id}_${uniqueKey}`
          "
          data-vv-as="遞延期間"
          v-model="productDataScope.deferred_prod"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(deferredOption, index) in extra__deferredOption"
            :key="index"
            :value="deferredOption"
          >
            {{ deferredOption }}
          </option>
        </select>
        <span v-if="extra__deferredMaturString" class="pl-1">{{
          extra__deferredMaturString
        }}</span>
      </div>
    </div>
    <div class="form-group row" v-if="isSpillover">
      <div class="col-12 d-flex align-items-center">
        <!--「FitBack健康吧」會員等級 -->
        <label>「FitBack健康吧」會員等級:</label>
        <select
          :disabled="!isAdulthood"
          class="form-control"
          :ref="`${mainIndex}fit_back'`"
          style="width: 10rem"
          :id="mainIndex + 'fit_back'"
          :data-vv-name="mainIndex + 'fit_back'"
          :class="{ 'is-invalid': errors.has(mainIndex + 'fit_back') }"
          v-validate="`required`"
          data-vv-as="會員等級"
          v-model="productDataScope.level"
          @change="itemMemberLevelChangeHandler()"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(level, index) in option.level_option"
            :key="'fit_back_level' + level.paraval"
            :value="level.paraval"
          >
            {{ level.paradetlno }}
          </option>
        </select>
        <div class="text-red notice ml_2" v-if="!isAdulthood">
          主約被保險人未滿18歲
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-12 d-flex align-items-center">
        <!-- 繳別 -->
        <label>繳別:</label>
        <select
          class="form-control"
          :ref="`${mainIndex}pay_freq'`"
          style="width: 7rem"
          :id="mainIndex + 'pay_freq'"
          :data-vv-name="mainIndex + 'pay_freq'"
          :class="{ 'is-invalid': errors.has(mainIndex + 'pay_freq') }"
          v-validate="`required`"
          data-vv-as="繳別"
          v-model="productDataScope.pay_freq"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(payFreqOption, index) in option.payFreq_option"
            :key="index.paraval"
            :value="payFreqOption.paraval"
          >
            {{ payFreqOption.paradetlno }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group row" v-if="PRODUCT_FEATURE_DATA.job_ind != '0'">
      <div class="col-12 d-flex align-items-center">
        <!-- 職業別 -->
        <label>職業別:</label>
        <select
          class="form-control"
          style="width: 7rem"
          :id="mainIndex + 'job_cat'"
          :data-vv-name="mainIndex + 'job_cat'"
          :class="{
            'is-invalid': errors.has(mainIndex + 'job_cat'),
          }"
          v-validate="`required||checkJob_${productData.prod_id}_${uniqueKey}`"
          data-vv-as="繳別"
          v-model="productDataScope.job_cat"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(jobOption, index) in option.job_option"
            :key="index.paraval"
            :value="jobOption.value"
          >
            {{ jobOption.text }}
          </option>
        </select>
        <a
          class="queryJobClassify ml_12"
          target="__blank"
          @click="jobPickingOpen = true"
          >查詢職業類別 ></a
        >
      </div>
      <!-- 職業分類POP -->
      <job-picking-modal
        :open="jobPickingOpen"
        @submit="submitJob"
        @close="jobPickingOpen = false"
      />
    </div>
    <div class="form-group mb_0 row">
      <!-- 繳費方式折減 -->
      <div class="col-12 col-lg-4 col-xl-3 d-flex align-items-center mb_12">
        <label :for="mainIndex + 'pay_dis'">繳費方式折減:</label>
        <select
          class="form-control"
          style="width: 12.3rem"
          :id="mainIndex + 'pay_dis'"
          v-model="productDataScope.pay_dis"
          @change="productDataScope.group_dis = '0'"
        >
          <option
            v-for="(payDisOption, index) in option.payDis_option"
            :key="index.paraval"
            :value="payDisOption.paraval"
          >
            {{ payDisOption.paradetlno }}
          </option>
        </select>
      </div>
      <div class="col-12 col-lg-8 col-xl-9 d-flex align-items-center mb_12">
        <!-- 集彙折減 -->
        <label :for="mainIndex + 'group_dis'">集彙折減:</label>
        <select
          class="form-control"
          style="width: 10rem"
          :id="mainIndex + 'group_dis'"
          v-model="productDataScope.group_dis"
          :disabled="productDataScope.pay_dis != '1'"
        >
          <option
            v-for="(groupDisOption, index) in option.groupDis_option"
            :key="index.paraval"
            :value="groupDisOption.paraval"
          >
            {{ groupDisOption.paradetlno }}
          </option>
        </select>
        <div class="text-red notice ml_2">選擇金融轉帳始能選擇集彙優惠</div>
      </div>
    </div>
    <div
      class="form-group row"
      v-if="PRODUCT_FEATURE_DATA.life_pol_design_type != '2'"
    >
      <!-- 年度保單紅利給付方式 -->
      <div class="col-12 d-flex align-items-center">
        <!-- 年度保單紅利給付方式 -->
        <label>年度保單紅利給付方式:</label>
        <select
          class="form-control"
          style="width: 11rem"
          :id="mainIndex + 'div_type'"
          :data-vv-name="mainIndex + 'div_type'"
          :class="{ 'is-invalid': errors.has(mainIndex + 'div_type') }"
          v-model="productDataScope.div_type"
          v-validate="`required`"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(jobOption, index) in sourceList.div_type"
            :key="index.paraval"
            :value="jobOption.paraval"
          >
            {{ jobOption.paradetlno }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group row" v-if="isSensitive">
      <!-- 增值回饋分享金 -->
      <div class="col-12 d-flex align-items-center">
        <!-- 增值回饋分享金 -->
        <label>增值回饋分享金給付方式:</label>
        <select
          class="form-control auto-width-select"
          style="--select-width: 11rem"
          :id="mainIndex + 'add_method'"
          :data-vv-name="mainIndex + 'add_method'"
          :class="{ 'is-invalid': errors.has(mainIndex + 'add_method') }"
          v-model="productDataScope.add_method"
          v-validate="`required`"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(jobOption, index) in sourceList.add_method"
            :key="index.paraval"
            :value="jobOption.paraval"
          >
            {{ jobOption.paradetlno }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group row pt_4">
      <!-- 保額一般情況 -->
      <div
        class="col-xl-4 col-5 d-flex align-items-center"
        v-if="!extra__amtSelect"
      >
        <label :for="mainIndex + 'amt'">保額:</label>
        <div class="position-relative">
          <input
            type="text"
            @input="
              clearPremiumHandler();
              numberHandler(productDataScope, 'amt', $event);
            "
            @blur="numberHandler(productDataScope, 'amt', $event)"
            :value="productData.amt | formatMethods"
            class="form-control form-control-inline"
            style="width: 11rem"
            :class="{
              'is-invalid': errors.has(`amt`),
            }"
            v-validate="`required|checkAMT_${productData.prod_id}_${uniqueKey}`"
            data-vv-name="amt"
            maxlength="15"
            :disabled="amt_floor == amt_ceil && amt_floor + amt_ceil != 0"
            :placeholder="
              amtPlaceholderShow
                ? `${formatMethods(amt_floor)}~${formatMethods(amt_ceil)}`
                : ''
            "
          />
          <div
            class="notice-top text-red"
            v-show="amt_floor != amt_ceil"
            v-if="
              PRODUCT_FEATURE_DATA.amt_incr_unit !== '0' &&
              PRODUCT_FEATURE_DATA.amt_incr_unit / amt_formatVal != 1 &&
              !(
                PRODUCT_FEATURE_DATA.amt_unit == '7' ||
                PRODUCT_FEATURE_DATA.amt_unit == '8' ||
                PRODUCT_FEATURE_DATA.col_amt == '1'
              )
            "
          >
            {{
              `需以${
                PRODUCT_FEATURE_DATA.amt_incr_unit / amt_formatVal
              }${unit_curr(
                PRODUCT_FEATURE_DATA.amt_unit,
                PRODUCT_FEATURE_DATA.curr
              )}為單位`
            }}
          </div>
        </div>
        <span>{{
          unit_curr(PRODUCT_FEATURE_DATA.amt_unit, PRODUCT_FEATURE_DATA.curr)
        }}</span>
      </div>
      <!-- 保額 FX4那種下拉選單的 -->
      <div class="col-xl-4 col-5 d-flex align-items-center" v-else>
        <label :for="mainIndex + 'amt'">保額:</label>
        <div class="position-relative">
          <select
            class="form-control"
            style="width: 10.3rem"
            :id="mainIndex + 'pay_dis'"
            v-model="productDataScope.amt"
            @change="clearPremiumHandler()"
          >
            <option value="" disabled>請選擇</option>
            <option
              v-for="amtItem in extra__amtList"
              :key="amtItem"
              :value="amtItem"
            >
              {{ amtItem }}
            </option>
          </select>
        </div>
        <span>{{
          unit_curr(PRODUCT_FEATURE_DATA.amt_unit, PRODUCT_FEATURE_DATA.curr)
        }}</span>
      </div>
      <div class="col-xl-8 col-7 d-flex align-items-center">
        <div class="btn btn-default" @click="calcPremium()">換算保費</div>
        <div class="noPremium ml_2" v-if="productDataScope.premiumShow">
          折扣前保費{{ productDataScope.premium | formatMethods }}
          {{ currTranser(PRODUCT_FEATURE_DATA.curr, true) }}
        </div>
        <div
          class="noPremium ml_2"
          v-else-if="
            productDataScope.premium && productDataScope.premium == '0'
          "
        >
          無對應保費
        </div>
      </div>
    </div>
    <div class="form-group row pt_4" v-if="!extra__amtSelect">
      <div class="col-xl-4 col-5 d-flex align-items-center">
        <!-- 或預估投入保費: -->
        <label :for="mainIndex + 'estimatePremium'">或預估投入保費:</label>
        <div class="position-relative">
          <input
            type="text"
            @input="
              clearAmtHandler();
              numberHandler(productDataScope, 'estimatePremium', $event);
            "
            @blur="numberHandler(productDataScope, 'estimatePremium', $event)"
            :value="productData.estimatePremium | formatMethods"
            class="form-control form-control-inline"
            style="width: 11rem"
            :class="{
              'is-invalid': errors.has(`estimatePremium`),
            }"
            data-vv-name="estimatePremium"
            maxlength="15"
          />
          <div class="notice-top">非必要欄位，可不輸入</div>
        </div>
        <span>{{ currTranser(PRODUCT_FEATURE_DATA.curr, true) }}</span>
      </div>
      <div class="col-xl-8 col-7 d-flex align-items-center">
        <div class="btn btn-default" @click="convertPremiumToAmount()">
          換算保額
        </div>
        <div
          class="text-red notice ml_2"
          v-show="productDataScope.estimatePremiumError"
        >
          錯誤!請依本商品之規定正確輸入!
        </div>
      </div>
    </div>
    <!-- 有留slot放附約選擇組件 -->
    <slot></slot>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import moment from "moment";
import _ from "lodash";
import { Validator } from "vee-validate";
import JobPickingModal from "./JobPickingModal";

export default {
  //注意，這邊productData是直接傳遞外部物件，直接上方v-model是直接修改外部物件內的屬性
  props: ["mainIndex", "productData", "uniqueKey", "validPayPrdOption"],
  mixins: [mf_Mixin],
  components: { JobPickingModal },
  data() {
    return {
      productDataScope: _.cloneDeep(this.productData),
      premium: "",
      computeDiscountPremium: "",
      //下方全部皆為依照商品而變動的部分
      sourceList: {
        pay_freq: [],
        pay_dis: [],
        group_dis: [],
        add_method: [],
        div_type: [],
      },
      extra__payPeriodMatur: false, //繳費年期後方要顯示"歲滿額"
      extra__showPolPeriod: false, //需顯示保險期間
      extra__polPeriodOption: [], //保險期間下拉選單內容
      extra__polPeriodMatur: false, //保險期間後方要顯示"歲滿額"
      extra__deferredOption: [], //遞延期間(8/2新增)下拉選單內容
      extra__showDeferred: false, //遞延期間(8/2新增)
      extra__deferredMaturString: "", //遞延期間後方文字
      extra__amtSelect: false, //保額須採用下拉選項的模式
      extra__amtList: [], //續上，下拉清單
      extra__oui: false, //OUI商品
      extra_pay_to_pol: false, //保險期間與繳費年期index連動
      timer: null,
      amt_ceil: 0,
      amt_floor: 0,
      errorMessage: "",
      whiteListErrorMessage: "", //被保人未在商品白名單，提示文字
      amtPlaceholderShow: false,
      errorReason: "一般", //無法承保的原因類別
      jobPickingOpen: false,
      memberLevel: "",
      has_hnw: false, //高資產商品
    };
  },
  computed: {
    PRODUCT_FEATURE_DATA() {
      return this.productData.FEATURE_DATA;
    },
    amt_formatVal() {
      if (this.productData.FEATURE_DATA.amt_unit == "") {
        return 1;
      } else {
        return this.$amtUnitFormat(this.productData.FEATURE_DATA.amt_unit);
      }
    },
    isSensitive() {
      return this.PRODUCT_FEATURE_DATA.int_ind === "1";
    },
    isSpillover() {
      return (
        this.productData.FEATURE_DATA.cwp_level === "1" ||
        this.productData.FEATURE_DATA.is_spillover4 === "1"
      );
    },
    isAdulthood() {
      return (
        !isNaN(Number(this.$store.getters.MfEditing.insured.insured_age)) &&
        Number(this.$store.getters.MfEditing.insured.insured_age) >= 18
      );
    },

    option() {
      //繳費年期
      let _periodType = this.PRODUCT_FEATURE_DATA.pay_prd.split(",");
      let periodType_option = [];
      // 自動續保機制處理。.僅主約，在繳費年期所有判斷之前，先判斷mfm00100.renew_type，
      // 若等於"3"或"4"，則下拉清單只有1，也不需判斷歲滿期(2022/03/21新增)。
      // 此處產生「完整繳費年期清單」，提供原本連動邏輯使用。年期展開及 renew_type 3、4 的規則，必須與：Index.vue > getPeriodOptionList()、getPayPrdOptionList() 保持一致。
      if (
        this.PRODUCT_FEATURE_DATA.renew_type == "3" ||
        this.PRODUCT_FEATURE_DATA.renew_type == "4"
      ) {
        periodType_option.push("1");
      } else {
        //年期波浪計算
        _periodType.forEach((item) => {
          if (item.indexOf("~") > 0) {
            let startIndex = parseInt(item.split("~")[0]);
            let endIndex = parseInt(item.split("~")[1]);
            for (let i = startIndex; i <= endIndex; i++) {
              periodType_option.push(i.toString());
            }
          } else {
            periodType_option.push(item);
          }
        });
      }

      //繳別
      let _payFreq = this.PRODUCT_FEATURE_DATA.pay_freq.split(",");
      let payFreq_option = this.sourceList.pay_freq.filter((item) => {
        return _payFreq.includes(item.paraval);
      });
      //繳費方式折減
      let _payDis = this.PRODUCT_FEATURE_DATA.pay_dis.split(",");
      let payDis_option = this.sourceList.pay_dis.filter((item) => {
        return _payDis.includes(item.paraval);
      });
      //職業別
      let job_option = [];
      if (this.PRODUCT_FEATURE_DATA.job_ind != "0") {
        let start = parseInt(this.PRODUCT_FEATURE_DATA.job_start);
        let end = parseInt(this.PRODUCT_FEATURE_DATA.job_end);
        for (let i = start; i <= end; i++) {
          job_option.push({
            text: i.toString(),
            value: i.toString(),
          });
        }
      }
      //集彙折減
      let _groupDis = this.PRODUCT_FEATURE_DATA.group_dis.split(",");
      let groupDis_option = this.sourceList.group_dis.filter((item) => {
        return _groupDis.includes(item.paraval);
      });
      let level_option = this.sourceList.level_nm;
      return {
        periodType_option, // 保留完整年期，提供原本連動邏輯使用
        payFreq_option,
        payDis_option,
        groupDis_option,
        job_option,
        level_option,
      };
    },
    insured() {
      return (
        this.$store.getters.MfEditing.insured || {
          insured_id: "",
        }
      );
    },
  },
  created() {
    this.init();
    this.initValidator();
  },
  methods: {
    async init() {
      this.errorMessage = "";
      this.whiteListErrorMessage = await this.checkProdWhiteList(
        this.productData.prod_id,
        this.$store.getters.MfEditing.insured.insured_id
      );
      //查詢單位(以及背後所代表的值)
      this.sourceList.gender_ind = this.$paragrpno.gender_ind;
      this.sourceList.pay_freq = this.$paragrpno.pay_freq;
      this.sourceList.pay_dis = this.$paragrpno.pay_dis;
      this.sourceList.group_dis = this.$paragrpno.group_dis;
      this.sourceList.level_nm = this.$paragrpno.level_nm;
      if (this.PRODUCT_FEATURE_DATA.life_pol_design_type != "2") {
        this.sourceList.div_type = this.$paragrpno.div_type.filter((method) => {
          return (
            this.PRODUCT_FEATURE_DATA.div_type.indexOf(method.paraval) > -1
          );
        });
      }
      this.sourceList.add_method = this.$paragrpno.add_method.filter(
        (method) => {
          return (
            this.PRODUCT_FEATURE_DATA.add_method.indexOf(method.paraval) > -1
          );
        }
      );
      // 自動續保機制處理。.僅主約，在繳費年期所有判斷之前，先判斷mfm00100.renew_type，
      // 若等於"3"或"4"，則下拉清單只有1，也不需判斷歲滿期(2022/03/21新增)。
      if (
        this.PRODUCT_FEATURE_DATA.renew_type == "3" ||
        this.PRODUCT_FEATURE_DATA.renew_type == "4"
      ) {
        this.PRODUCT_FEATURE_DATA.pay_period_matur = "0";
      }

      if (this.PRODUCT_FEATURE_DATA.job_ind == "0") {
        //配合調整主附約職業類別連動，提供無職業類別主約暫存變數(提供附約統一職業類別用)
        let temp_sc_prod = this.productDataScope.sc_prod_list.find(
          (item) => item.job_cat !== ""
        );
        let temp_job_cat = "1";
        if (temp_sc_prod) {
          temp_job_cat = temp_sc_prod.job_cat;
        }
        this.productDataScope.temp_job_cat = temp_job_cat;
      } else {
        if (!this.productDataScope.job_cat) {
          this.productDataScope.job_cat = "1";
        }
      }
      if (
        this.productDataScope.temp_level &&
        this.productDataScope.temp_level !== ""
      ) {
        this.productDataScope.level = this.productDataScope.temp_level;
      }
      //呼叫額外處理for特殊商品
      this.extraHandler();
      // 等特殊欄位建立完成後，再執行預帶
      this.$nextTick(() => {
        this.setDefaultPeriodValue();
      });
    },
    initValidator() {
      let main = () => {
        // 自動續保機制處理。.僅主約，在繳費年期所有判斷之前，先判斷mfm00100.renew_type，
        // 若等於"3"或"4"，則下拉清單只有1，也不需判斷歲滿期(2022/03/21新增)。
        if (
          this.PRODUCT_FEATURE_DATA.renew_type == "3" ||
          this.PRODUCT_FEATURE_DATA.renew_type == "4"
        ) {
          this.PRODUCT_FEATURE_DATA.pay_period_matur = "0";
        }
        this.errorMessage = "";
        //判斷年齡區間是否符合(判斷amt_ind_list(優先)或age_ind_list)
        let age_ind_list = this.PRODUCT_FEATURE_DATA.age_ind_list;
        let amt_ind_list = this.PRODUCT_FEATURE_DATA.amt_ind_list;
        let ageRangeList = [];
        if (age_ind_list) {
          ageRangeList = age_ind_list.filter((item) => {
            if (item.pay_prd && item.reserve_col != "-1") {
              if (
                this.PRODUCT_FEATURE_DATA.pol_period.split(",").length > 1 ||
                this.PRODUCT_FEATURE_DATA.pol_period.split("~").length > 1
              ) {
                this.errorReason = "保險期間";
                if (item.pay_prd && item.pay_prd != "-1") {
                  return (
                    item.pay_prd == this.productDataScope.pay_prd &&
                    item.reserve_col == this.productDataScope.pol_period
                  );
                } else {
                  return item.reserve_col == this.productDataScope.pol_period;
                }
              } else if (
                this.PRODUCT_FEATURE_DATA.deferred_prod &&
                this.PRODUCT_FEATURE_DATA.deferred_prod.split(",").length > 0
              ) {
                //遞延年金檢核(8/10新增)
                this.errorReason = "遞延期間";
                if (item.pay_prd && item.pay_prd != "-1") {
                  return (
                    item.pay_prd == this.productDataScope.pay_prd &&
                    item.reserve_col == this.productDataScope.deferred_prod
                  );
                } else {
                  return (
                    item.reserve_col == this.productDataScope.deferred_prod
                  );
                }
              } else {
                this.errorReason = "繳費年期";
                return item.pay_prd == this.productDataScope.pay_prd;
              }
            } else if (item.pay_prd != "-1") {
              this.errorReason = "繳費年期";
              return item.pay_prd == this.productDataScope.pay_prd;
            }
          });
        }
        if (amt_ind_list) {
          ageRangeList = amt_ind_list.filter((item) => {
            if (item.pay_prd != "-1") {
              this.errorReason = "繳費年期";
              return item.pay_prd == this.productDataScope.pay_prd;
            }
          });
        }
        let insured_age = this.$store.getters.MfEditing.insured.insured_age;
        let insured_gender =
          this.$store.getters.MfEditing.insured.insured_gender;
        //調整繳費年期、繳別、年齡後，動態計算保額限制
        let amtRange = amt_ind_list
          ? amt_ind_list.find((item) => {
              let result = true;
              if (item.age_ceil != "-1" || item.age_floor != "-1") {
                if (
                  parseInt(insured_age) < parseInt(item.age_floor) ||
                  parseInt(insured_age) > parseInt(item.age_ceil)
                ) {
                  result = false;
                }
              }

              if (item.gender != "-1") {
                //性別影響上限
                if (insured_gender != item.gender) {
                  result = false;
                }
              }
              if (item.pay_prd != "-1" && this.productDataScope.pay_prd != "") {
                //繳費年期影響上限
                if (this.productDataScope.pay_prd != item.pay_prd) {
                  result = false;
                }
              }
              if (
                item.pay_freq != "-1" &&
                this.productDataScope.pay_freq != ""
              ) {
                //繳別影響上限
                if (this.productDataScope.pay_freq != item.pay_freq) {
                  result = false;
                }
              }
              if (
                item.reserve_col != "-1" &&
                this.$store.getters.MfEditing.insured.insured_age != ""
              ) {
                //特殊欄位(到達年齡)影響上限
                if (
                  this.$store.getters.MfEditing.insured.insured_age !=
                  item.reserve_col
                ) {
                  result = false;
                }
              }
              return result;
            })
          : {
              amt_ceil: this.PRODUCT_FEATURE_DATA.amt_ceil,
              amt_floor: this.PRODUCT_FEATURE_DATA.amt_floor,
            };
        if (amtRange) {
          this.amt_ceil = amtRange.amt_ceil / this.amt_formatVal;
          this.amt_floor = amtRange.amt_floor / this.amt_formatVal;
          //有職業類別保額上限限制(2022/03/22新增)
          if (
            this.PRODUCT_FEATURE_DATA.renew_type_list &&
            this.PRODUCT_FEATURE_DATA.renew_type_list.length > 0
          ) {
            let renew_type = this.PRODUCT_FEATURE_DATA.renew_type_list.find(
              (item) => {
                return item.job_cat == this.productDataScope.job_cat;
              }
            );
            if (renew_type) {
              //如果職業類別的上限比較低才替換
              if (parseInt(renew_type.amt_ceil) < this.amt_ceil) {
                this.amt_ceil = parseInt(renew_type.amt_ceil);
              }
            }
          }
          if (this.amt_ceil == this.amt_floor) {
            //保額上下限制相同時，自動帶入
            setTimeout(() => {
              this.productDataScope.amt = this.amt_ceil;
            });
          }
          this.$forceUpdate();
        }

        //輸出承保年齡
        let age_floor = 0;
        let age_ceil = 0;
        try {
          age_floor = ageRangeList[0].age_floor;
          age_ceil = ageRangeList[0].age_ceil;
          ageRangeList.forEach((ageRange) => {
            if (parseInt(ageRange.age_floor) < parseInt(age_floor)) {
              age_floor = ageRange.age_floor;
            }
            if (parseInt(ageRange.age_ceil) > parseInt(age_ceil)) {
              age_ceil = ageRange.age_ceil;
            }
          });
        } catch {
          age_floor = this.PRODUCT_FEATURE_DATA.age_floor;
          age_ceil = this.PRODUCT_FEATURE_DATA.age_ceil;
        }
        return {
          age_floor,
          age_ceil,
        };
      };
      let prod_id = this.productData.prod_id;
      //檢核保額
      Validator.extend(`checkAMT_${prod_id}_${this.uniqueKey}`, {
        getMessage: "",
        validate: (value) => {
          main();
          //是否符合保額遞增單位
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.amt_incr_unit / this.amt_formatVal;

          let intValue = parseInt(value.split(",").join(""));
          return (
            intValue >= this.amt_floor &&
            intValue <= this.amt_ceil &&
            (incr_unit == 0 ? true : intValue % incr_unit == 0)
          );
        },
      });
      //檢核年期&性別
      Validator.extend(`checkPrd_${prod_id}_${this.uniqueKey}`, {
        getMessage: "",
        validate: (value) => {
          let { age_floor, age_ceil } = main();
          let insured_age = this.$store.getters.MfEditing.insured.insured_age;
          let insured_age_floor =
            this.$store.getters.MfEditing.insured.insured_age; //被保人年齡(檢核下限用，預設值:保險年齡)
          let isFullyear = false;
          //區分法定年齡與保險年齡邏輯(2022/3/18新增 )
          if (this.PRODUCT_FEATURE_DATA.age_floor_kind == "2") {
            isFullyear = true;
          }
          if (
            this.PRODUCT_FEATURE_DATA.age_floor_kind == "2" &&
            this.$store.getters.MfEditing.insured.insured_birthday != ""
          ) {
            //使用實際年齡
            insured_age_floor = moment().diff(
              moment(this.$store.getters.MfEditing.insured.insured_birthday),
              "years"
            );
          }

          let insured_sex =
            this.$store.getters.MfEditing.insured.insured_gender;
          let prod_sex = this.PRODUCT_FEATURE_DATA.gender_ind;
          let errorMessage_sex = "";
          if (prod_sex != 0 && prod_sex != insured_sex) {
            let sexStr = this.sourceList.gender_ind
              .filter((item) => item.paraval === prod_sex)
              .map((item) => item.paradetlno);
            errorMessage_sex = "主約被保險人限" + sexStr + "性。";
          }

          if (
            parseInt(this.PRODUCT_FEATURE_DATA.matur_age_ceil) > 0 &&
            (parseInt(insured_age_floor) < parseInt(age_floor) ||
              parseInt(insured_age) > parseInt(age_ceil) ||
              parseInt(insured_age) + parseInt(this.productDataScope.pay_prd) >
                parseInt(this.PRODUCT_FEATURE_DATA.matur_age_ceil))
          ) {
            this.errorReason = "繳費期滿";
            if (this.PRODUCT_FEATURE_DATA.pay_period_matur === "1") {
              this.errorReason = "歲滿期";
            }
            this.$nextTick(() => {
              switch (this.errorReason) {
                case "繳費期滿":
                  this.errorMessage = `主約被保險人限${age_floor}${
                    isFullyear ? "足" : ""
                  }歲至${age_ceil}歲；繳費期滿不超過${
                    this.PRODUCT_FEATURE_DATA.matur_age_ceil
                  }歲。`;
                  break;
                case "歲滿期":
                  this.errorMessage = `選擇${value}歲滿期，主約被保險人限${age_floor}${
                    isFullyear ? "足" : ""
                  }歲至${age_ceil}歲。`;
                  break;
              }
              this.errorMessage = this.errorMessage + errorMessage_sex;
              this.$forceUpdate();
            });
            return false;
          }
          if (
            parseInt(this.PRODUCT_FEATURE_DATA.matur_age_ceil) == 0 &&
            (parseInt(insured_age_floor) < parseInt(age_floor) ||
              parseInt(insured_age) > parseInt(age_ceil))
          ) {
            if (this.PRODUCT_FEATURE_DATA.pay_period_matur === "1") {
              this.errorReason = "歲滿期";
            }
            this.$nextTick(() => {
              switch (this.errorReason) {
                case "一般":
                  this.errorMessage = `主約被保險人限${age_floor}${
                    isFullyear && age_floor != 0 ? "足" : ""
                  }歲至${age_ceil}歲。`;
                  break;
                case "繳費年期":
                  this.errorMessage = `選擇繳費年期${value}年，主約被保險人限${age_floor}至${age_ceil}歲。`;
                  break;
                case "歲滿期":
                  this.errorMessage = `選擇${value}歲滿期，主約被保險人限${age_floor}${
                    isFullyear ? "足" : ""
                  }歲至${age_ceil}歲。`;
                  break;
                case "保險期間":
                  if (this.productDataScope.pol_period != "") {
                    this.errorMessage = `選擇繳費年期${value}年，選擇保險期間${this.productDataScope.pol_period}年，主約被保險人限${age_floor}歲至${age_ceil}歲`;
                  } else {
                    this.errorMessage = `選擇繳費年期${value}年，主約被保險人限${age_floor}歲至${age_ceil}歲`;
                  }
                  break;
                case "遞延期間":
                  if (this.productDataScope.deferred_prod != "") {
                    this.errorMessage = `選擇繳費年期${value}年，選擇遞延期間${this.productDataScope.deferred_prod}年，主約被保險人限${age_floor}歲至${age_ceil}歲`;
                  } else {
                    this.errorMessage = `選擇繳費年期${value}年，主約被保險人限${age_floor}歲至${age_ceil}歲`;
                  }
              }
              this.errorMessage = this.errorMessage + errorMessage_sex;
              this.$forceUpdate();
            });
            return false;
          }

          if (errorMessage_sex !== "") {
            this.errorMessage = errorMessage_sex;
            return false;
          }
          return true;
        },
      });
      //檢核保險期間
      Validator.extend(`checkPol_${prod_id}_${this.uniqueKey}`, {
        getMessage: "",
        validate: (value) => {
          let { age_floor, age_ceil } = main();
          let insured_age = this.$store.getters.MfEditing.insured.insured_age;
          if (
            parseInt(this.PRODUCT_FEATURE_DATA.matur_age_ceil) == 0 &&
            (parseInt(insured_age) < parseInt(age_floor) ||
              parseInt(insured_age) > parseInt(age_ceil))
          ) {
            this.$nextTick(() => {
              this.errorMessage = `選擇繳費年期${this.productDataScope.pay_prd}年，選擇保險期間${value}年，主約被保險人限${age_floor}歲至${age_ceil}歲`;
              this.$forceUpdate();
            });
            return false;
          }
          return true;
        },
      });
      //檢核遞延期間
      Validator.extend(`checkDeferred_${prod_id}_${this.uniqueKey}`, {
        getMessage: "",
        validate: (value) => {
          let { age_floor, age_ceil } = main();
          console.log("遞延期間", age_floor, age_ceil);
          let insured_age = this.$store.getters.MfEditing.insured.insured_age;
          if (
            parseInt(this.PRODUCT_FEATURE_DATA.matur_age_ceil) == 0 &&
            (parseInt(insured_age) < parseInt(age_floor) ||
              parseInt(insured_age) > parseInt(age_ceil))
          ) {
            this.$nextTick(() => {
              this.errorMessage = `選擇繳費年期${this.productDataScope.pay_prd}年，選擇遞延期間${value}年，主約被保險人限${age_floor}歲至${age_ceil}歲`;
              this.$forceUpdate();
            });
            return false;
          }
          return true;
        },
      });
      // //職業類別
      Validator.extend(`checkJob_${prod_id}_${this.uniqueKey}`, {
        getMessage: "",
        validate: (value) => {
          main();
          return true;
        },
      });
    },
    async validateAll(needNotice) {
      const checkResult = await this.$validator.validateAll();
      if (!checkResult && needNotice) {
        this.$toast.info({
          title: "請檢視必填欄位是否漏填或填寫內容有誤! ",
        });
      }
      return checkResult;
    },
    async calcPremium() {
      let check = await this.validateAll();
      if (check) {
        this.$mfAPI
          .MFC0_1000__getPremium({
            prod_id: this.productDataScope.prod_id,
            add_method: this.productDataScope.add_method,
            amt: this.productDataScope.amt,
            group_dis: this.productDataScope.group_dis,
            job_cat: this.productDataScope.job_cat,
            pay_dis: this.productDataScope.pay_dis,
            pay_freq: this.productDataScope.pay_freq,
            pay_prd: this.productDataScope.pay_prd,
            pol_period: this.productDataScope.pol_period,
            deferred_prod: this.productDataScope.deferred_prod, //遞延基金
            insured_age: this.$store.getters.MfEditing.insured.insured_age + "",
            insured_gender:
              this.$store.getters.MfEditing.insured.insured_gender,
          })
          .then((res) => {
            this.productDataScope.premium = res.premium;
            this.productDataScope.premiumShow = true;
            this.$forceUpdate();
          });
      } else {
        this.productDataScope.premium = "0";
      }
    },
    async convertPremiumToAmount() {
      if (!this.productDataScope.pay_freq || !this.productDataScope.pay_prd) {
        this.productDataScope.estimatePremiumError = true;
        this.$forceUpdate();
        return this.$toast.info({
          title: `請檢視預估投入保費是否漏填或填寫內容有誤!`,
        });
      }
      this.productDataScope.premiumShow = false;
      if (parseInt(this.productDataScope.estimatePremium + 0) < 1) {
        this.productDataScope.estimatePremiumError = true;
        this.$forceUpdate();
        return this.$toast.info({
          title: `請檢視預估投入保費是否漏填或填寫內容有誤!`,
        });
      }
      this.$mfAPI
        .MFC0_1000__convertPremiumToAmount({
          prod_id: this.productDataScope.prod_id,
          pay_prd: this.productDataScope.pay_prd,
          pay_freq: this.productDataScope.pay_freq,
          pay_dis: this.productDataScope.pay_dis,
          group_dis: this.productDataScope.group_dis,
          job_cat: this.productDataScope.job_cat,
          pol_period: this.productDataScope.pol_period,
          deferred_prod: this.productDataScope.deferred_prod, //遞延期間
          insured_age: this.$store.getters.MfEditing.insured.insured_age,
          insured_gender: this.$store.getters.MfEditing.insured.insured_gender,
          premium: this.productDataScope.estimatePremium,
        })
        .then((res) => {
          if (this.amt_ceil != this.amt_floor) {
            let amt_incr_unit =
              this.PRODUCT_FEATURE_DATA.amt_incr_unit == "0"
                ? 1
                : this.PRODUCT_FEATURE_DATA.amt_incr_unit;
            this.productDataScope.amt =
              (Math.floor(res.amt / amt_incr_unit, 0) * amt_incr_unit) /
              this.amt_formatVal;
          }

          this.$nextTick(() => this.calcPremium());
        });
    },
    //特殊商品額外處理
    extraHandler() {
      //判斷特殊情況1：繳費年期後方是否需要顯示歲滿期
      if (this.PRODUCT_FEATURE_DATA.pay_period_matur === "1") {
        this.extra__payPeriodMatur = true;
      }
      //判斷特殊情況2：保險期間有兩個以上且same_pay_period=0,則顯示保險期間選項
      let _pol_period = this.PRODUCT_FEATURE_DATA.pol_period.split(",");

      //年期波浪計算
      _pol_period.forEach((item) => {
        if (item.indexOf("~") > 0) {
          let startIndex = parseInt(item.split("~")[0]);
          let endIndex = parseInt(item.split("~")[1]);
          for (let i = startIndex; i <= endIndex; i++) {
            this.extra__polPeriodOption.push(i.toString());
          }
        } else {
          this.extra__polPeriodOption.push(item);
        }
      });
      if (
        this.PRODUCT_FEATURE_DATA.same_pay_period === "0" &&
        this.extra__polPeriodOption.length > 1
      ) {
        this.extra__showPolPeriod = true;
      } else {
        if (this.PRODUCT_FEATURE_DATA.same_pay_period === "0") {
          this.productDataScope.pol_period =
            this.PRODUCT_FEATURE_DATA.pol_period;
        } else {
          // 此邏輯必須與 Index.vue > getCheckPolPeriodOption() 保持一致。
          this.productDataScope.pol_period = this.productDataScope.pay_prd;
        }
      }
      //特殊情況2延伸， 如果該商品在pay_to_pol清單內，則跟繳費年期index連動
      if (
        this.$special_array("pay_to_pol").includes(
          this.productDataScope.prod_id
        )
      ) {
        this.extra_pay_to_pol = true;
      }
      //保險期間要呈現歲滿期
      if (this.PRODUCT_FEATURE_DATA.matur === "1") {
        this.extra__polPeriodMatur = true;
      }
      //判斷特殊情況3：FX4等特殊情況需要將保額變成下拉選單
      if (this.PRODUCT_FEATURE_DATA.col_amt === "1") {
        this.extra__amtSelect = true;
        this.extra__amtList = this.PRODUCT_FEATURE_DATA.amt_list.split(",");
      }
      //判斷特殊情況4：OUI商品將分享金固定為增息
      if (this.PRODUCT_FEATURE_DATA.oiu_ind === "1") {
        this.extra__oui = true;
        this.productDataScope.add_method = "2";
      }
      //判斷特殊情況5：遞延期間(8/2新增)
      if (this.PRODUCT_FEATURE_DATA.deferred_prod) {
        this.extra__showDeferred = true;
        this.extra__deferredOption =
          this.PRODUCT_FEATURE_DATA.deferred_prod.split(",");
        if (this.PRODUCT_FEATURE_DATA.dly_prd_type == "1") {
          this.extra__deferredMaturString = "年滿期";
        } else if (this.PRODUCT_FEATURE_DATA.dly_prd_type == "2") {
          this.extra__deferredMaturString = "歲滿期";
        }
      }
      var hnw_list = this.$special_array("hnw");
      if (hnw_list.includes(this.productData.prod_id)) {
        this.has_hnw = true;
      }
    },
    // 預帶繳費年期及遞延期間
    setDefaultPeriodValue() {
      // 1. 預帶繳費年期，模擬使用者選擇
      if (!this.productDataScope.pay_prd) {
        let defaultPayPrd =
          this.getDefaultPayPrdValue(
            this.validPayPrdOption
          );

        if (defaultPayPrd !== "") {
          this.changePeriod({
            target: {
              value: defaultPayPrd,
            },
          });
          // 預帶不是實際的 change 事件，因此主動重新驗證
          this.$nextTick(() => {
            this.$validator.validate(
              `${this.mainIndex}pay_prd`
            );
          });
        }
      }
      // 2. 遞延期間只有一個選項才預帶
      if (
        this.extra__showDeferred &&
        !this.productDataScope.deferred_prod
      ) {
        let defaultDeferredProd =
          this.getSingleOptionValue(
            this.extra__deferredOption
          );
        if (defaultDeferredProd !== "") {
          this.productDataScope.deferred_prod =
            defaultDeferredProd;
        }
      }
    },
    // 取得繳費年期預帶值
    getDefaultPayPrdValue(optionList) {
      let validOptionList = (optionList || []).filter(
        (item) => item !== ""
      );

      if (
        this.PRODUCT_FEATURE_DATA.prod_type == "1" &&
        this.PRODUCT_FEATURE_DATA.int_ind == "0"
      ) {
        if (validOptionList.length === 0) {
          return "";
        }
        // 只有一個選項，預帶唯一值
        if (validOptionList.length === 1) {
          return validOptionList[0];
        }

        let sortedOptionList = validOptionList.sort(
          (a, b) => Number(a) - Number(b)
        );
        // 三個選項預帶中間值
        if (sortedOptionList.length === 3) {
          return sortedOptionList[1];
        }
        // 兩個或四個以上預帶最高值
        return sortedOptionList[
          sortedOptionList.length - 1
        ];
      } else {
        // 其他商品只有一個選項才預帶
        return this.getSingleOptionValue(validOptionList);
      }
    },
    getSingleOptionValue(optionList) {
      let validOptionList = (optionList || []).filter(
        (item) => item !== ""
      );
      if (validOptionList.length === 1) {
        return validOptionList[0];
      }
      return "";
    },
    changePeriod(val) {
      //需與保險期間連動
      // 此邏輯必須與 Index.vue > getCheckPolPeriodOption() 保持一致。
      if (this.extra_pay_to_pol) {
        let index = this.option.periodType_option.indexOf(val.target.value);
        this.productDataScope.pol_period = this.extra__polPeriodOption[index];
      }
      if (
        this.productDataScope.pay_prd != "" &&
        this.productDataScope.sc_prod_list.length > 0
      ) {
        let temp = val.target.value; //暫存
        setTimeout(() => {
          val.target.value = this.productDataScope.pay_prd;
          this.$mfNotice(
            "重新選擇主約繳費年期，部份需與主約繳費年期相同之附約將跟著變更；若變更後與附約本身規定不符則將自動剔除該附約，是否仍要重新選擇主約繳費年期?",
            () => {
              this.productDataScope.pay_prd = temp;
              val.target.value = temp;
              // 判斷是否需要砍掉繳費年齡不符合的SC
              //過濾不合格的
              this.productDataScope.sc_prod_list.forEach((item) => {
                if (item.is_checked) {
                  if (
                    this.getProdvalid(
                      item,
                      item.insured_age,
                      item.pay_prd ? this.productDataScope.pay_prd : "1",
                      this.productDataScope.pol_period,
                      "",
                      item.insured_birthday,
                      item.deferred_prod,
                      this.$store.getters.MfEditing.insured.insured_gender
                    ) != ""
                  ) {
                    item.is_checked = "0";
                  }
                }
              });
            },
            true
          );
        }, 1);
      } else {
        this.productDataScope.pay_prd = val.target.value;
      }
    },
    clearPremiumHandler() {
      setTimeout(() => {
        this.productDataScope.premiumShow = false;
        this.productDataScope.premium = "";
        this.productDataScope.estimatePremium = "";
        this.productDataScope.estimatePremiumError = false;
        this.$forceUpdate();
      }, 10);
    },
    clearAmtHandler() {
      setTimeout(() => {
        this.productDataScope.estimatePremiumError = false;
        this.productDataScope.premiumShow = false;
        this.productDataScope.premium = "";
        if (this.amt_ceil != this.amt_floor) {
          this.productDataScope.amt = "";
        }
        this.$forceUpdate();
      }, 10);
    },
    submitJob(job) {
      if (parseInt(job.job_cat) > parseInt(this.option.job_option.length)) {
        this.productDataScope.job_cat = "";
      } else {
        this.productDataScope.job_cat = job.job_cat;
      }
      this.jobPickingOpen = false;
    },
    itemMemberLevelChangeHandler() {
      this.productDataScope.temp_level = this.productDataScope.level;
    },

    //比對選項及預設選項排序取得預設選項
    pickDefault(pre_definedable, preference) {
      if (!Array.isArray(pre_definedable) || pre_definedable.length === 0)
        return null;
      const set = new Set(pre_definedable);
      for (const p of preference) {
        if (set.has(p)) return p;
      }
      // 如果沒有比對到可用選項則預設選項第一個可用選項
      return pre_definedable[0];
    },
  },
  watch: {
    productDataScope: {
      handler() {
        this.$emit("update:productData", this.productDataScope);
      },
      deep: true,
    },
    "productDataScope.pay_prd": {
      handler() {
        this.productDataScope.premiumShow = false;
        this.productDataScope.estimatePremium = "";
        if (this.productDataScope.amt != "") {
          this.calcPremium();
        }
        if (
          this.productDataScope.pay_prd != "" &&
          this.getProdvalid(
            this.PRODUCT_FEATURE_DATA,
            this.$store.getters.MfEditing.insured.insured_age,
            this.productDataScope.pay_prd,
            this.productDataScope.pol_period,
            "",
            this.productDataScope.insured_birthday,
            this.productDataScope.deferred_prod,
            this.$store.getters.MfEditing.insured.insured_gender
          ) == "" &&
          this.productDataScope.pay_prd != ""
        ) {
          if (
            this.PRODUCT_FEATURE_DATA.job_ind != "0" &&
            this.productDataScope.job_cat == ""
          ) {
            this.amtPlaceholderShow = false;
          } else {
            this.amtPlaceholderShow = true;
          }
        } else {
          this.amtPlaceholderShow = false;
        }
        if (this.PRODUCT_FEATURE_DATA.same_pay_period !== "0") {
          this.productDataScope.pol_period = this.productDataScope.pay_prd;
        }
        this.initValidator();
        if (this.productDataScope.deferred_prod && this.extra__showDeferred) {
          this.$validator.validate(`${this.mainIndex}deferred_prod`);
        }
        if (this.productDataScope.pol_period && this.extra__showPolPeriod) {
          this.$validator.validate(`${this.mainIndex}pol_period`);
        }
        this.$forceUpdate();
      },
      immediate: true,
    },
    "productDataScope.pay_freq": {
      handler() {
        this.productDataScope.premiumShow = false;
        this.productDataScope.estimatePremium = "";
        if (this.productDataScope.amt != "") {
          this.calcPremium();
        }
        this.initValidator();
        this.$forceUpdate();
      },
    },
    "productDataScope.pol_period": {
      handler() {
        if (this.extra_pay_to_pol) return;
        this.productDataScope.premiumShow = false;
        this.productDataScope.estimatePremium = "";
        if (this.productDataScope.amt != "") {
          this.calcPremium();
        }
        this.initValidator();
        if (this.productDataScope.pay_prd) {
          this.$validator.validate(`${this.mainIndex}pay_prd`);
        }
        this.$forceUpdate();
      },
    },
    "productDataScope.deferred_prod": {
      handler() {
        if (this.productDataScope.pay_prd) {
          this.$validator.validate(`${this.mainIndex}pay_prd`);
        }
      },
    },
    "productDataScope.job_cat": {
      handler() {
        this.productDataScope.premiumShow = false;
        this.productDataScope.estimatePremium = "";
        if (this.productDataScope.amt != "") {
          this.calcPremium();
        }
        if (this.productDataScope.pay_prd == "") {
          this.amtPlaceholderShow = false;
        } else {
          this.amtPlaceholderShow = true;
        }
        this.initValidator();
        this.$forceUpdate();
      },
    },
    "productData.sc_prod_list": {
      handler(val) {
        this.productDataScope.sc_prod_list = this.productData.sc_prod_list;
      },
    },
    "productData.job_cat": {
      handler(val) {
        this.productDataScope.job_cat = val;
      },
    },
    "productDataScope.level": {
      handler() {
        this.$emit("update:productData", this.productDataScope);
      },
      immediate: true,
    },
    "option.payFreq_option": {
      immediate: false,
      handler(val) {
        //比對取得繳別預設值，若有一個選項以上則預帶規則為：年繳>半年繳>季繳>月繳
        if (!this.productDataScope.pay_freq) {
          var pre_defined_payFreq_option = ["4", "3", "2", "1"]; //預帶選項規則順序
          var default_pay_freq = this.pickDefault(
            this.option.payFreq_option.map((item) => item.paraval),
            pre_defined_payFreq_option
          );
          //設定繳別預設值
          this.productDataScope.pay_freq = default_pay_freq;
        }
      },
    },
    "option.payDis_option": {
      immediate: false,
      handler(val) {
        //比對取得費方式折減預設值，若為單一選項，則預帶該選項(如「無」)；若有一個選項以上則預帶規則為：金融轉帳1%>無繳費方式優惠>其他選項
        if (!this.productDataScope.pay_dis) {
          var pre_defined_payDis_option = ["1", "0", "2"];
          var default_pay_dis = this.pickDefault(
            this.option.payDis_option.map((item) => item.paraval),
            pre_defined_payDis_option
          );
          //設定繳費方式折減預設值
          this.productDataScope.pay_dis = default_pay_dis;
        }
      },
    },
    "sourceList.add_method": {
      immediate: false,
      handler(val) {
        if (!this.productDataScope.add_method) {
          //比對取得增值回饋分享金給付方式預設值，若為單一選項，則預帶該選項，若有一個選項以上則預帶「增額繳清」>「儲存生息」>「儲存生息且主動給付」>其他選項
          var pre_defined_add_method = ["1", "2", "3"];
          var default_add_method = this.pickDefault(
            this.sourceList.add_method.map((item) => item.paraval),
            pre_defined_add_method
          );
          //設定增值回饋分享金給付方式預設值
          this.productDataScope.add_method = default_add_method;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.MainProductInputItem {
  padding: 30px 0;
  border-bottom: solid 1px #c2c4c7;
  label {
    font-weight: 700;
    margin-right: 8px;
    line-height: 40px;
    white-space: nowrap;
  }
  select.form-control.is-invalid {
    padding-right: 1rem !important;
    background-position: right 0.5rem center;
  }
  .auto-width-select {
    display: inline-block;
    width: unquote("max(var(--select-width), fit-content)") !important;
    padding-right: 1.5rem;
  }
  .notice {
    color: #de4054;
    line-height: 40px;
    font-size: 13px;
  }
  .notice-large {
    color: #de4054;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    white-space: normal !important;
  }
  .form-group {
    margin-bottom: 20px;
  }
  .form-group span {
    line-height: 40px;
    margin-left: 10px;
    display: inline-block;
  }
  .noPremium {
    flex-grow: 0;
    background-color: #fff3c2;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    color: #323a45;
    font-size: 16px;
    font-weight: bold;
  }
}
.queryJobClassify {
  color: #048f3a;
  text-decoration: underline;
  font-size: 14px;
  text-align: right;
  font-weight: 700;
  cursor: pointer;
}
</style>
